import CryptoJS from 'crypto-js';
import { postApi, handleStoreApiError } from '../../lib/fetcher';
import { btoa, atob } from '../../lib/helpers';

const settingSpeFee = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      totalPage: 0,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    removeSingleData(state, { index }) {
      state.totalData -= 1;
      state.allData = state.allData.filter((value) => value.mcc != index);
    },

    addData(state) {
      state.totalData += 1;
    },

    pushData(state, { payload }) {
      state.allData.push(payload);
    },

    editData(state, { payload, index }) {
      Object.assign(state.allData[index], payload);
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      ctx.commit('clearData');
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        search,
        sort_by: 'id ASC',
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/setting-fee/fee-spe`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setTotalData', {
          payload: responseData,
        });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async createData(ctx, { date, value }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        fee_name: value.fee_name,
        fee_sharing: value.fee_sharing,
        volume_month_min: value.volume_month_min,
        volume_month_max: value.volume_month_max,
        volume_status: value.volume_status ? 1 : 0,
        start_month: value.start_month,
        start_year: value.start_year,
        version: btoa(
          CryptoJS.SHA256(
            value.fee_name +
              value.fee_sharing +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/setting-fee/fee-spe/create`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code != '200') {
        handleStoreApiError(ctx, responseData);
      } else {
        ctx.commit('pushData', {
          payload: responseData.data,
        });
        ctx.commit('addData');

        return true;
      }

      return false;
    },

    async updateData(ctx, { date, value, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: value.id,
        fee_name: value.fee_name,
        fee_sharing: value.fee_sharing,
        volume_month_min: value.volume_month_min,
        volume_month_max: value.volume_month_max,
        volume_status: value.volume_status ? 1 : 0,
        start_month: value.start_month,
        start_year: value.start_year,
        version: btoa(
          CryptoJS.SHA256(
            value.id +
              value.fee_name +
              value.fee_sharing +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/setting-fee/fee-spe/update`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code != '200') {
        handleStoreApiError(ctx, responseData);
      } else {
        ctx.commit('editData', {
          payload: responseData.data,
          index,
        });

        return true;
      }

      return false;
    },
  },
};

export default settingSpeFee;
